/**
 * Alarm Module
 * Footer floating alarm initialization
 */
export function initAlarm() {
  console.log("Initializing Alarm...");
  initFooterAlarm();
}

function initFooterAlarm() {
  const alarm = document.querySelector(".floating-alarm");

  if (!alarm) return;

  const action = alarm.querySelector(".floating-alarm__action");
  const audio = alarm.querySelector(".floating-alarm__audio");
  const media = alarm.querySelectorAll(".floating-alarm__media-img");

  if (!action || !audio || media.length < 2) return;

  // Always reset alarm state on page load / refresh
  action.checked = false;
  audio.pause();
  audio.currentTime = 0;

  media.forEach((img, index) => {
    img.classList.toggle("active", index === 0);
  });

  action.addEventListener("change", () => {
    if (action.checked) {
      // Play audio continuously
      audio.loop = true;
      audio.currentTime = 0;

      audio.play().catch((error) => {
        console.warn("Alarm audio could not be played:", error);
      });

      // Switch image
      media[0].classList.remove("active");
      media[1].classList.add("active");
    } else {
      // Stop audio
      audio.pause();
      audio.currentTime = 0;

      // Switch image back
      media[1].classList.remove("active");
      media[0].classList.add("active");
    }
  });
}
